import { useMemo, ReactNode } from 'react';

import { useToken } from 'src/features/auth';
import { useGetPermissions } from 'src/features/auth/api/useGetPermissions';
import AuthContext from 'src/features/auth/context/AuthContext';
import { useParking } from 'src/providers/ParkingProvider.tsx';

function AuthProvider({ children }: { children: ReactNode }) {
    const { data: tokenData, isPending: isTokenPending } = useToken();
    const { parkingId } = useParking();
    const { data: permissions, isLoading: isPermissionsLoading } = useGetPermissions({
        config: { enabled: !!tokenData },
        parkingId: parkingId,
    });

    const value = useMemo(
        () => ({
            permissions: permissions || [],
            permissionsLoaded: !isTokenPending && !isPermissionsLoading,
        }),
        [permissions, isPermissionsLoading, isTokenPending],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export { AuthProvider };
